<button mat-raised-button color="primary"  [disabled]="!generatorId"` (click)="openAddEditStreamDialog('Add',0,null)">
    <mat-icon>add</mat-icon> Add Stream
</button>
<div class="mat-elevation-z8 viewport mar-top-20">
    <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="streamName">
            <th mat-header-cell *matHeaderCellDef> Stream Name </th>
            <td mat-cell *matCellDef="let element"> {{element.streamName}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="uom">
            <th mat-header-cell *matHeaderCellDef> UOM </th>
            <td mat-cell *matCellDef="let element"> {{element.uomText}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef> Quantity </th>
            <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="tipFee">
            <th mat-header-cell *matHeaderCellDef> Tip Fee </th>
            <td mat-cell *matCellDef="let element"> {{element.tipFee}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="rebateTotal">
            <th mat-header-cell *matHeaderCellDef> Rebate Total </th>
            <td mat-cell *matCellDef="let element"> {{element.rebateTotal}} </td>
            <td mat-footer-cell *matFooterCellDef class="rebate-footer-total">
                {{getRebateTotal() | number: '1.2'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef> Total </th>
            <td mat-cell *matCellDef="let element"> {{element.total}} </td>
            <td mat-footer-cell *matFooterCellDef class="footer-total">
              {{getGrandTotal() | number: '1.2'}}
            </td>
        </ng-container>
        <!-- <ng-container matColumnDef="aD_RebateUOMText">
            <th mat-header-cell *matHeaderCellDef> Rebate UOM </th>
            <td mat-cell *matCellDef="let element"> {{element.aD_RebateUOMText}} </td>
        </ng-container>
        <ng-container matColumnDef="aD_RebateQty">
            <th mat-header-cell *matHeaderCellDef> Rebate Qty </th>
            <td mat-cell *matCellDef="let element"> {{element.aD_RebateQty}} </td>
        </ng-container>
        <ng-container matColumnDef="rebateValue">
            <th mat-header-cell *matHeaderCellDef> Rebate Amount </th>
            <td mat-cell *matCellDef="let element"> {{element.rebateValue}} </td>
        </ng-container> -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let row">
                <div style="margin-left: -13px;">
                    <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit"
                        (click)="openAddEditStreamDialog('Edit',row.id,row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button type="button" color="warn" title="Delete" style="color: red;"
                        (click)="deleteStream(row)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
                <!-- } -->
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedAdditionalStreamColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedAdditionalStreamColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedAdditionalStreamColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No streams found.</td>
        </tr>
    </table>
</div>
